import { useMemo } from "react";
import { motion } from "framer-motion";

const COLORS = ["#E30B5C", "#FF5C8A", "#FFB6C1", "#FF8FA3"];

const Petal = ({ color }) => (
  <svg viewBox="0 0 24 24" width="100%" height="100%">
    <path
      d="M12 1 C18 5 21 11 19 17 C17 22 12 23 12 23 C12 23 7 22 5 17 C3 11 6 5 12 1 Z"
      fill={color}
      opacity="0.9"
    />
    <path d="M12 3 C15 7 16 12 14 18" stroke="rgba(255,255,255,0.4)" strokeWidth="1" fill="none" />
  </svg>
);

export default function FallingPetals({ count = 16 }) {
  const petals = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: Math.random() * 96,
        size: 18 + Math.random() * 18,
        fall: 9 + Math.random() * 9,
        delay: Math.random() * 9,
        drift: 30 + Math.random() * 50,
        spin: 360 + Math.random() * 360,
        color: COLORS[i % COLORS.length],
      })),
    [count]
  );

  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-0" aria-hidden="true">
      {petals.map((p) => (
        <motion.div
          key={p.id}
          className="absolute"
          style={{ left: `${p.left}%`, width: p.size, top: -40 }}
          animate={{
            y: [0, window.innerHeight + 120],
            x: [0, p.drift, -p.drift, p.drift / 2],
            rotate: [0, p.spin],
            rotateX: [0, 180, 360],
          }}
          transition={{ duration: p.fall, delay: p.delay, repeat: Infinity, ease: "linear" }}
        >
          <Petal color={p.color} />
        </motion.div>
      ))}
    </div>
  );
}
